export const styleSheet = (props) => ({
  card: {
    marginBottom: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    borderRadius: '8px',
  },
  tabCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 0.3s ease-in-out',
    '& .MuiTabs-root': {
      backgroundColor: '#f5f5f5',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
    },
    '& .MuiTab-root': {
      textTransform: 'none',
      fontWeight: 500,
      minHeight: '48px',
      '&.Mui-selected': {
        backgroundColor: '#fff',
        borderTop: '2px solid #1976d2',
      },
    },
  },
  diagnosticHeader: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    padding: '2rem',
    borderRadius: '8px',
    marginBottom: '2rem',
  },
  tabContent: {
    padding: '24px',
    minHeight: '400px',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
  },
  errorContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    color: '#d32f2f',
  },
});
